const TripDashboardViewModes = {
  CLIENT_VIEW: 0,
  OPERATOR_VIEW: 1
}

const UserRoles = {
  SuperAdmin: 1,
  Operator: 2,
  Client: 3
}

export { TripDashboardViewModes, UserRoles }
